"use strict";
var _createClass = (function () {
        function i(e, t) {
            for (var n = 0; n < t.length; n++) {
                var i = t[n];
                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
            }
        }
        return function (e, t, n) {
            return t && i(e.prototype, t), n && i(e, n), e;
        };
    })(),
    _typeof =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                return typeof e;
            }
            : function (e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
function _classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
!(function (t) {
    var i = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
    function e(e, t) {
        return e((t = { exports: {} }), t.exports), t.exports;
    }
    var p,
        h,
        g,
        b,
        s,
        m,
        T,
        v,
        u,
        y,
        l,
        c,
        n,
        o,
        a,
        r,
        d,
        f;
    (function () {
    }.call(window),
        (function (u, a, g, b) {
            if (((u.console = u.console || { info: function (e) {} }), g))
                if (g.fn.fancybox) console.info("fancyBox already initialized");
                else {
                    var e,
                        t = {
                            loop: !1,
                            gutter: 50,
                            keyboard: !0,
                            arrows: !0,
                            infobar: !0,
                            smallBtn: "auto",
                            toolbar: "auto",
                            buttons: ["zoom", "thumbs", "close"],
                            idleTime: 3,
                            protect: !1,
                            modal: !1,
                            image: { preload: !1 },
                            ajax: { settings: { data: { fancybox: !0 } } },
                            iframe: {
                                tpl:
                                    '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen allowtransparency="true" src=""></iframe>',
                                preload: !0,
                                css: {},
                                attr: { scrolling: "auto" },
                            },
                            defaultType: "image",
                            animationEffect: "zoom",
                            animationDuration: 366,
                            zoomOpacity: "auto",
                            transitionEffect: "fade",
                            transitionDuration: 366,
                            slideClass: "",
                            baseClass: "",
                            baseTpl:
                                '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar"></div><div class="fancybox-navigation"></div><div class="fancybox-stage"></div><div class="fancybox-caption"></div></div></div>',
                            spinnerTpl: '<div class="fancybox-loading"></div>',
                            errorTpl: '<div class="fancybox-error"><p></p></div>',
                            btnTpl: {
                                download:
                                    '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="" href="javascript:;"><svg viewBox="0 0 40 40"><path d="M13,16 L20,23 L27,16 M20,7 L20,23 M10,24 L10,28 L30,28 L30,24" /></svg></a>',
                                zoom:
                                    '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title=""><svg viewBox="0 0 40 40"><path d="M18,17 m-8,0 a8,8 0 1,0 16,0 a8,8 0 1,0 -16,0 M24,22 L31,29" /></svg></button>',
                                close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title=""><svg viewBox="0 0 40 40"><path d="M10,10 L30,30 M30,10 L10,30" /></svg></button>',
                                smallBtn: '<button data-fancybox-close class="fancybox-close-small" title=""><svg viewBox="0 0 32 32"><path d="M10,10 L22,22 M22,10 L10,22"></path></svg></button>',
                                arrowLeft:
                                    '<a data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="" href="javascript:;"><svg viewBox="0 0 40 40"><path d="M18,12 L10,20 L18,28 M10,20 L30,20"></path></svg></a>',
                                arrowRight:
                                    '<a data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="" href="javascript:;"><svg viewBox="0 0 40 40"><path d="M10,20 L30,20 M22,12 L30,20 L22,28"></path></svg></a>',
                            },
                            parentEl: "body",
                            autoFocus: !1,
                            backFocus: !0,
                            trapFocus: !0,
                            fullScreen: { autoStart: !1 },
                            touch: { vertical: !0, momentum: !0 },
                            hash: null,
                            media: {},
                            slideShow: { autoStart: !1, speed: 4e3 },
                            thumbs: { autoStart: !1, hideOnClose: !0, parentEl: ".fancybox-container", axis: "y" },
                            wheel: "auto",
                            onInit: g.noop,
                            beforeLoad: g.noop,
                            afterLoad: g.noop,
                            beforeShow: g.noop,
                            afterShow: g.noop,
                            beforeClose: g.noop,
                            afterClose: g.noop,
                            onActivate: g.noop,
                            onDeactivate: g.noop,
                            clickContent: function (e, t) {
                                return "image" === e.type && "zoom";
                            },
                            clickSlide: "close",
                            clickOutside: "close",
                            dblclickContent: !1,
                            dblclickSlide: !1,
                            dblclickOutside: !1,
                            mobile: {
                                idleTime: !1,
                                clickContent: function (e, t) {
                                    return "image" === e.type && "toggleControls";
                                },
                                clickSlide: function (e, t) {
                                    return "image" === e.type ? "toggleControls" : "close";
                                },
                                dblclickContent: function (e, t) {
                                    return "image" === e.type && "zoom";
                                },
                                dblclickSlide: function (e, t) {
                                    return "image" === e.type && "zoom";
                                },
                            },
                            lang: "en",
                            i18n: {
                                en: {
                                    CLOSE: "Close",
                                    NEXT: "Next",
                                    PREV: "Previous",
                                    ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                                    PLAY_START: "Start slideshow",
                                    PLAY_STOP: "Pause slideshow",
                                    FULL_SCREEN: "Full screen",
                                    THUMBS: "Thumbnails",
                                    DOWNLOAD: "Download",
                                    SHARE: "Share",
                                    ZOOM: "Zoom",
                                },
                                de: {
                                    CLOSE: "Schliessen",
                                    NEXT: "Weiter",
                                    PREV: "Zurück",
                                    ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.",
                                    PLAY_START: "Diaschau starten",
                                    PLAY_STOP: "Diaschau beenden",
                                    FULL_SCREEN: "Vollbild",
                                    THUMBS: "Vorschaubilder",
                                    DOWNLOAD: "Herunterladen",
                                    SHARE: "Teilen",
                                    ZOOM: "Maßstab",
                                },
                            },
                        },
                        o = g(u),
                        s = g(a),
                        r = 0,
                        f =
                            u.requestAnimationFrame ||
                            u.webkitRequestAnimationFrame ||
                            u.mozRequestAnimationFrame ||
                            u.oRequestAnimationFrame ||
                            function (e) {
                                return u.setTimeout(e, 1e3 / 60);
                            },
                        p = (function () {
                            var e,
                                t = a.createElement("fakeelement"),
                                n = { transition: "transitionend", OTransition: "oTransitionEnd", MozTransition: "transitionend", WebkitTransition: "webkitTransitionEnd" };
                            for (e in n) if (t.style[e] !== b) return n[e];
                            return "transitionend";
                        })(),
                        l = function (e, t) {
                            var n = g.extend(!0, {}, e, t);
                            return (
                                g.each(t, function (e, t) {
                                    g.isArray(t) && (n[e] = t);
                                }),
                                    n
                            );
                        },
                        i = function (e, t, n) {
                            var i = this;
                            (i.opts = l({ index: n }, g.fancybox.defaults)),
                            g.isPlainObject(t) && (i.opts = l(i.opts, t)),
                            g.fancybox.isMobile && (i.opts = l(i.opts, i.opts.mobile)),
                                (i.id = i.opts.id || ++r),
                                (i.currIndex = parseInt(i.opts.index, 10) || 0),
                                (i.prevIndex = null),
                                (i.prevPos = null),
                                (i.currPos = 0),
                                (i.firstRun = !0),
                                (i.group = []),
                                (i.slides = {}),
                                i.addContent(e),
                            i.group.length && ((i.$lastFocus = g(a.activeElement).trigger("blur")), i.init());
                        };
                    g.extend(i.prototype, {
                        init: function () {
                            var e,
                                t,
                                n,
                                i = this,
                                o = i.group[i.currIndex].opts,
                                r = g.fancybox.scrollbarWidth;
                            g.fancybox.getInstance() ||
                            !1 === o.hideScrollbar ||
                            (g("body").addClass("fancybox-active"),
                            !g.fancybox.isMobile &&
                            a.body.scrollHeight > u.innerHeight &&
                            (r === b && ((e = g('<div style="width:100px;height:100px;overflow:scroll;" />').appendTo("body")), (r = g.fancybox.scrollbarWidth = e[0].offsetWidth - e[0].clientWidth), e.remove()),
                                g("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar { margin-right: ' + r + "px; }</style>"),
                                g("body").addClass("compensate-for-scrollbar"))),
                                (n = ""),
                                g.each(o.buttons, function (e, t) {
                                    n += o.btnTpl[t] || "";
                                }),
                                (t = g(i.translate(i, o.baseTpl.replace("", n).replace("", o.btnTpl.arrowLeft + o.btnTpl.arrowRight)))
                                    .attr("id", "fancybox-container-" + i.id)
                                    .addClass("fancybox-is-hidden")
                                    .addClass(o.baseClass)
                                    .data("FancyBox", i)
                                    .appendTo(o.parentEl)),
                                (i.$refs = { container: t }),
                                ["bg", "inner", "infobar", "toolbar", "stage", "caption", "navigation"].forEach(function (e) {
                                    i.$refs[e] = t.find(".fancybox-" + e);
                                }),
                                i.trigger("onInit"),
                                i.activate(),
                                i.jumpTo(i.currIndex);
                        },
                        translate: function (e, t) {
                            var i = e.opts.i18n[e.opts.lang];
                            return t.replace(/\{\{(\w+)\}\}/g, function (e, t) {
                                var n = i[t];
                                return n === b ? e : n;
                            });
                        },
                        addContent: function (e) {
                            var t,
                                c = this,
                                n = g.makeArray(e);
                            g.each(n, function (e, t) {
                                var n,
                                    i,
                                    o,
                                    r,
                                    a,
                                    s = {},
                                    l = {};
                                g.isPlainObject(t)
                                    ? (l = (s = t).opts || t)
                                    : "object" === g.type(t) && g(t).length
                                        ? ((l = (n = g(t)).data() || {}), ((l = g.extend(!0, {}, l, l.options)).$orig = n), (s.src = c.opts.src || l.src || n.attr("href")), s.type || s.src || ((s.type = "inline"), (s.src = t)))
                                        : (s = { type: "html", src: t + "" }),
                                    (s.opts = g.extend(!0, {}, c.opts, l)),
                                g.isArray(l.buttons) && (s.opts.buttons = l.buttons),
                                    (i = s.type || s.opts.type),
                                    (r = s.src || ""),
                                !i &&
                                r &&
                                ((o = r.match(/\.(mp4|mov|ogv)((\?|#).*)?$/i))
                                    ? ((i = "video"), s.opts.videoFormat || (s.opts.videoFormat = "video/" + ("ogv" === o[1] ? "ogg" : o[1])))
                                    : r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)
                                        ? (i = "image")
                                        : r.match(/\.(pdf)((\?|#).*)?$/i)
                                            ? (i = "iframe")
                                            : "#" === r.charAt(0) && (i = "inline")),
                                    i ? (s.type = i) : c.trigger("objectNeedsType", s),
                                s.contentType || (s.contentType = -1 < g.inArray(s.type, ["html", "inline", "ajax"]) ? "html" : s.type),
                                    (s.index = c.group.length),
                                "auto" == s.opts.smallBtn && (s.opts.smallBtn = -1 < g.inArray(s.type, ["html", "inline", "ajax"])),
                                "auto" === s.opts.toolbar && (s.opts.toolbar = !s.opts.smallBtn),
                                s.opts.$trigger && s.index === c.opts.index && (s.opts.$thumb = s.opts.$trigger.find("img:first")),
                                (s.opts.$thumb && s.opts.$thumb.length) || !s.opts.$orig || (s.opts.$thumb = s.opts.$orig.find("img:first")),
                                "function" === g.type(s.opts.caption) && (s.opts.caption = s.opts.caption.apply(t, [c, s])),
                                "function" === g.type(c.opts.caption) && (s.opts.caption = c.opts.caption.apply(t, [c, s])),
                                s.opts.caption instanceof g || (s.opts.caption = s.opts.caption === b ? "" : s.opts.caption + ""),
                                "ajax" === s.type && 1 < (a = r.split(/\s+/, 2)).length && ((s.src = a.shift()), (s.opts.filter = a.shift())),
                                s.opts.modal &&
                                (s.opts = g.extend(!0, s.opts, {
                                    infobar: 0,
                                    toolbar: 0,
                                    smallBtn: 0,
                                    keyboard: 0,
                                    slideShow: 0,
                                    fullScreen: 0,
                                    thumbs: 0,
                                    touch: 0,
                                    clickContent: !1,
                                    clickSlide: !1,
                                    clickOutside: !1,
                                    dblclickContent: !1,
                                    dblclickSlide: !1,
                                    dblclickOutside: !1,
                                })),
                                    c.group.push(s);
                            }),
                            Object.keys(c.slides).length && (c.updateControls(), (t = c.Thumbs) && t.isActive && (t.create(), t.focus()));
                        },
                        addEvents: function () {
                            var i = this;
                            i.removeEvents(),
                                i.$refs.container
                                    .on("click.fb-close", "[data-fancybox-close]", function (e) {
                                        e.stopPropagation(), e.preventDefault(), i.close(e);
                                    })
                                    .on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", function (e) {
                                        e.stopPropagation(), e.preventDefault(), i.previous();
                                    })
                                    .on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", function (e) {
                                        e.stopPropagation(), e.preventDefault(), i.next();
                                    })
                                    .on("click.fb", "[data-fancybox-zoom]", function (e) {
                                        i[i.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
                                    }),
                                o.on("orientationchange.fb resize.fb", function (e) {
                                    e && e.originalEvent && "resize" === e.originalEvent.type
                                        ? f(function () {
                                            i.update();
                                        })
                                        : (i.$refs.stage.hide(),
                                            setTimeout(
                                                function () {
                                                    i.$refs.stage.show(), i.update();
                                                },
                                                g.fancybox.isMobile ? 600 : 250
                                            ));
                                }),
                                s.on("focusin.fb", function (e) {
                                    var t = g.fancybox ? g.fancybox.getInstance() : null;
                                    t.isClosing ||
                                    !t.current ||
                                    !t.current.opts.trapFocus ||
                                    g(e.target).hasClass("fancybox-container") ||
                                    g(e.target).is(a) ||
                                    (t && "fixed" !== g(e.target).css("position") && !t.$refs.container.has(e.target).length && (e.stopPropagation(), t.focus()));
                                }),
                                s.on("keydown.fb", function (e) {
                                    var t = i.current,
                                        n = e.keyCode || e.which;
                                    if (t && t.opts.keyboard && !(e.ctrlKey || e.altKey || e.shiftKey || g(e.target).is("input") || g(e.target).is("textarea")))
                                        return 8 === n || 27 === n
                                            ? (e.preventDefault(), void i.close(e))
                                            : 37 === n || 38 === n
                                                ? (e.preventDefault(), void i.previous())
                                                : 39 === n || 40 === n
                                                    ? (e.preventDefault(), void i.next())
                                                    : void i.trigger("afterKeydown", e, n);
                                }),
                            i.group[i.currIndex].opts.idleTime &&
                            ((i.idleSecondsCounter = 0),
                                s.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", function (e) {
                                    (i.idleSecondsCounter = 0), i.isIdle && i.showControls(), (i.isIdle = !1);
                                }),
                                (i.idleInterval = u.setInterval(function () {
                                    i.idleSecondsCounter++, i.idleSecondsCounter >= i.group[i.currIndex].opts.idleTime && !i.isDragging && ((i.isIdle = !0), (i.idleSecondsCounter = 0), i.hideControls());
                                }, 1e3)));
                        },
                        removeEvents: function () {
                            o.off("orientationchange.fb resize.fb"),
                                s.off("focusin.fb keydown.fb .fb-idle"),
                                this.$refs.container.off(".fb-close .fb-prev .fb-next"),
                            this.idleInterval && (u.clearInterval(this.idleInterval), (this.idleInterval = null));
                        },
                        previous: function (e) {
                            return this.jumpTo(this.currPos - 1, e);
                        },
                        next: function (e) {
                            return this.jumpTo(this.currPos + 1, e);
                        },
                        jumpTo: function (e, i) {
                            var t,
                                n,
                                o,
                                r,
                                a,
                                s,
                                l,
                                c = this,
                                u = c.group.length;
                            if (!(c.isDragging || c.isClosing || (c.isAnimating && c.firstRun))) {
                                if (((e = parseInt(e, 10)), !(n = c.current ? c.current.opts.loop : c.opts.loop) && (e < 0 || u <= e))) return !1;
                                if (((t = c.firstRun = !Object.keys(c.slides).length), !(u < 2 && !t && c.isDragging))) {
                                    if (
                                        ((r = c.current),
                                            (c.prevIndex = c.currIndex),
                                            (c.prevPos = c.currPos),
                                            (o = c.createSlide(e)),
                                        1 < u && ((n || 0 < o.index) && c.createSlide(e - 1), (n || o.index < u - 1) && c.createSlide(e + 1)),
                                            (c.current = o),
                                            (c.currIndex = o.index),
                                            (c.currPos = o.pos),
                                            c.trigger("beforeShow", t),
                                            c.updateControls(),
                                            (s = g.fancybox.getTranslate(o.$slide)),
                                            (o.isMoved = (0 !== s.left || 0 !== s.top) && !o.$slide.hasClass("fancybox-animated")),
                                            (o.forcedDuration = b),
                                            g.isNumeric(i) ? (o.forcedDuration = i) : (i = o.opts[t ? "animationDuration" : "transitionDuration"]),
                                            (i = parseInt(i, 10)),
                                            t)
                                    )
                                        return (
                                            o.opts.animationEffect && i && c.$refs.container.css("transition-duration", i + "ms"),
                                                c.$refs.container.removeClass("fancybox-is-hidden"),
                                                c.$refs.container.addClass("fancybox-is-open"),
                                                o.$slide.addClass("fancybox-slide--previous"),
                                                c.loadSlide(o),
                                                o.$slide.removeClass("fancybox-slide--previous").addClass("fancybox-slide--current"),
                                                void c.preload("image")
                                        );
                                    g.each(c.slides, function (e, t) {
                                        g.fancybox.stop(t.$slide);
                                    }),
                                        o.$slide.removeClass("fancybox-slide--next fancybox-slide--previous").addClass("fancybox-slide--current"),
                                        o.isMoved
                                            ? ((a = Math.round(o.$slide.width())),
                                                g.each(c.slides, function (e, t) {
                                                    var n = t.pos - o.pos;
                                                    g.fancybox.animate(t.$slide, { top: 0, left: n * a + n * t.opts.gutter }, i, function () {
                                                        t.$slide.removeAttr("style").removeClass("fancybox-slide--next fancybox-slide--previous"), t.pos === c.currPos && ((o.isMoved = !1), c.complete());
                                                    });
                                                }))
                                            : c.$refs.stage.children().removeAttr("style"),
                                        o.isLoaded ? c.revealContent(o) : c.loadSlide(o),
                                        c.preload("image"),
                                    r.pos !== o.pos &&
                                    ((l = "fancybox-slide--" + (r.pos > o.pos ? "next" : "previous")),
                                        r.$slide.removeClass("fancybox-slide--complete fancybox-slide--current fancybox-slide--next fancybox-slide--previous"),
                                        (r.isComplete = !1),
                                    i &&
                                    (o.isMoved || o.opts.transitionEffect) &&
                                    (o.isMoved
                                        ? r.$slide.addClass(l)
                                        : ((l = "fancybox-animated " + l + " fancybox-fx-" + o.opts.transitionEffect),
                                            g.fancybox.animate(r.$slide, l, i, function () {
                                                r.$slide.removeClass(l).removeAttr("style");
                                            }))));
                                }
                            }
                        },
                        createSlide: function (e) {
                            var t,
                                n,
                                i = this;
                            return (
                                (n = (n = e % i.group.length) < 0 ? i.group.length + n : n),
                                !i.slides[e] &&
                                i.group[n] &&
                                ((t = g('<div class="fancybox-slide"></div>').appendTo(i.$refs.stage)), (i.slides[e] = g.extend(!0, {}, i.group[n], { pos: e, $slide: t, isLoaded: !1 })), i.updateSlide(i.slides[e])),
                                    i.slides[e]
                            );
                        },
                        scaleToActual: function (e, t, n) {
                            var i,
                                o,
                                r,
                                a,
                                s,
                                l = this,
                                c = l.current,
                                u = c.$content,
                                d = g.fancybox.getTranslate(c.$slide).width,
                                f = g.fancybox.getTranslate(c.$slide).height,
                                p = c.width,
                                h = c.height;
                            !l.isAnimating &&
                            u &&
                            "image" == c.type &&
                            c.isLoaded &&
                            !c.hasError &&
                            (g.fancybox.stop(u),
                                (l.isAnimating = !0),
                                (e = e === b ? 0.5 * d : e),
                                (t = t === b ? 0.5 * f : t),
                                ((i = g.fancybox.getTranslate(u)).top -= g.fancybox.getTranslate(c.$slide).top),
                                (i.left -= g.fancybox.getTranslate(c.$slide).left),
                                (a = p / i.width),
                                (s = h / i.height),
                                (o = 0.5 * d - 0.5 * p),
                                (r = 0.5 * f - 0.5 * h),
                            d < p && (0 < (o = i.left * a - (e * a - e)) && (o = 0), o < d - p && (o = d - p)),
                            f < h && (0 < (r = i.top * s - (t * s - t)) && (r = 0), r < f - h && (r = f - h)),
                                l.updateCursor(p, h),
                                g.fancybox.animate(u, { top: r, left: o, scaleX: a, scaleY: s }, n || 330, function () {
                                    l.isAnimating = !1;
                                }),
                            l.SlideShow && l.SlideShow.isActive && l.SlideShow.stop());
                        },
                        scaleToFit: function (e) {
                            var t,
                                n = this,
                                i = n.current,
                                o = i.$content;
                            !n.isAnimating &&
                            o &&
                            "image" == i.type &&
                            i.isLoaded &&
                            !i.hasError &&
                            (g.fancybox.stop(o),
                                (n.isAnimating = !0),
                                (t = n.getFitPos(i)),
                                n.updateCursor(t.width, t.height),
                                g.fancybox.animate(o, { top: t.top, left: t.left, scaleX: t.width / o.width(), scaleY: t.height / o.height() }, e || 330, function () {
                                    n.isAnimating = !1;
                                }));
                        },
                        getFitPos: function (e) {
                            var t,
                                n,
                                i,
                                o,
                                r,
                                a = e.$content,
                                s = e.width || e.opts.width,
                                l = e.height || e.opts.height,
                                c = {};
                            return (
                                !!(e.isLoaded && a && a.length) &&
                                ((o = {
                                    top: parseInt(e.$slide.css("paddingTop"), 10),
                                    right: parseInt(e.$slide.css("paddingRight"), 10),
                                    bottom: parseInt(e.$slide.css("paddingBottom"), 10),
                                    left: parseInt(e.$slide.css("paddingLeft"), 10),
                                }),
                                    (t = parseInt(this.$refs.stage.width(), 10) - (o.left + o.right)),
                                    (n = parseInt(this.$refs.stage.height(), 10) - (o.top + o.bottom)),
                                (s && l) || ((s = t), (l = n)),
                                    (i = Math.min(1, t / s, n / l)),
                                    (s = Math.floor(i * s)),
                                    (l = Math.floor(i * l)),
                                    "image" === e.type
                                        ? ((c.top = Math.floor(0.5 * (n - l)) + o.top), (c.left = Math.floor(0.5 * (t - s)) + o.left))
                                        : "video" === e.contentType && (s / (r = e.opts.width && e.opts.height ? s / l : e.opts.ratio || 16 / 9) < l ? (l = s / r) : l * r < s && (s = l * r)),
                                    (c.width = s),
                                    (c.height = l),
                                    c)
                            );
                        },
                        update: function () {
                            var n = this;
                            g.each(n.slides, function (e, t) {
                                n.updateSlide(t);
                            });
                        },
                        updateSlide: function (e, t) {
                            var n = this,
                                i = e && e.$content,
                                o = e.width || e.opts.width,
                                r = e.height || e.opts.height;
                            i && (o || r || "video" === e.contentType) && !e.hasError && (g.fancybox.stop(i), g.fancybox.setTranslate(i, n.getFitPos(e)), e.pos === n.currPos && ((n.isAnimating = !1), n.updateCursor())),
                                e.$slide.trigger("refresh"),
                                n.$refs.toolbar.toggleClass("compensate-for-scrollbar", e.$slide.get(0).scrollHeight > e.$slide.get(0).clientHeight),
                                n.trigger("onUpdate", e);
                        },
                        centerSlide: function (e, t) {
                            var n, i;
                            this.current && ((n = Math.round(e.$slide.width())), (i = e.pos - this.current.pos), g.fancybox.animate(e.$slide, { top: 0, left: i * n + i * e.opts.gutter, opacity: 1 }, t === b ? 0 : t, null, !1));
                        },
                        updateCursor: function (e, t) {
                            var n,
                                i = this,
                                o = i.current,
                                r = i.$refs.container.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-drag fancybox-can-zoomOut");
                            o &&
                            !i.isClosing &&
                            ((n = i.isZoomable()),
                                r.toggleClass("fancybox-is-zoomable", n),
                                g("[data-fancybox-zoom]").prop("disabled", !n),
                                n && ("zoom" === o.opts.clickContent || (g.isFunction(o.opts.clickContent) && "zoom" === o.opts.clickContent(o)))
                                    ? i.isScaledDown(e, t)
                                        ? r.addClass("fancybox-can-zoomIn")
                                        : o.opts.touch
                                            ? r.addClass("fancybox-can-drag")
                                            : r.addClass("fancybox-can-zoomOut")
                                    : o.opts.touch && "video" !== o.contentType && r.addClass("fancybox-can-drag"));
                        },
                        isZoomable: function () {
                            var e,
                                t = this.current;
                            if (t && !this.isClosing && "image" === t.type && !t.hasError) {
                                if (!t.isLoaded) return !0;
                                if (((e = this.getFitPos(t)), t.width > e.width || t.height > e.height)) return !0;
                            }
                            return !1;
                        },
                        isScaledDown: function (e, t) {
                            var n = !1,
                                i = this.current,
                                o = i.$content;
                            return e !== b && t !== b ? (n = e < i.width && t < i.height) : o && (n = (n = g.fancybox.getTranslate(o)).width < i.width && n.height < i.height), n;
                        },
                        canPan: function () {
                            var e,
                                t = !1,
                                n = this.current;
                            return "image" === n.type && (e = n.$content) && !n.hasError && ((t = this.getFitPos(n)), (t = 1 < Math.abs(e.width() - t.width) || 1 < Math.abs(e.height() - t.height))), t;
                        },
                        loadSlide: function (n) {
                            var e,
                                t,
                                i,
                                o = this;
                            if (!n.isLoading && !n.isLoaded) {
                                switch (((n.isLoading = !0), o.trigger("beforeLoad", n), (e = n.type), (t = n.$slide).off("refresh").trigger("onReset").addClass(n.opts.slideClass), e)) {
                                    case "image":
                                        o.setImage(n);
                                        break;
                                    case "iframe":
                                        o.setIframe(n);
                                        break;
                                    case "html":
                                        o.setContent(n, n.src || n.content);
                                        break;
                                    case "video":
                                        o.setContent(n, '<video class="fancybox-video" controls controlsList="nodownload"><source src="' + n.src + '" type="' + n.opts.videoFormat + "\">Your browser doesn't support HTML5 video</video");
                                        break;
                                    case "inline":
                                        g(n.src).length ? o.setContent(n, g(n.src)) : o.setError(n);
                                        break;
                                    case "ajax":
                                        o.showLoading(n),
                                            (i = g.ajax(
                                                g.extend({}, n.opts.ajax.settings, {
                                                    url: n.src,
                                                    success: function (e, t) {
                                                        "success" === t && o.setContent(n, e);
                                                    },
                                                    error: function (e, t) {
                                                        e && "abort" !== t && o.setError(n);
                                                    },
                                                })
                                            )),
                                            t.one("onReset", function () {
                                                i.abort();
                                            });
                                        break;
                                    default:
                                        o.setError(n);
                                }
                                return !0;
                            }
                        },
                        setImage: function (t) {
                            var e,
                                n,
                                i,
                                o,
                                r,
                                a = this,
                                s = t.opts.srcset || t.opts.image.srcset;
                            if (
                                ((t.timouts = setTimeout(function () {
                                    var e = t.$image;
                                    !t.isLoading || (e && e[0].complete) || t.hasError || a.showLoading(t);
                                }, 350)),
                                    s)
                            ) {
                                (o = u.devicePixelRatio || 1),
                                    (r = u.innerWidth * o),
                                    (i = s.split(",").map(function (e) {
                                        var i = {};
                                        return (
                                            e
                                                .trim()
                                                .split(/\s+/)
                                                .forEach(function (e, t) {
                                                    var n = parseInt(e.substring(0, e.length - 1), 10);
                                                    if (0 === t) return (i.url = e);
                                                    n && ((i.value = n), (i.postfix = e[e.length - 1]));
                                                }),
                                                i
                                        );
                                    })).sort(function (e, t) {
                                        return e.value - t.value;
                                    });
                                for (var l = 0; l < i.length; l++) {
                                    var c = i[l];
                                    if (("w" === c.postfix && c.value >= r) || ("x" === c.postfix && c.value >= o)) {
                                        n = c;
                                        break;
                                    }
                                }
                                !n && i.length && (n = i[i.length - 1]), n && ((t.src = n.url), t.width && t.height && "w" == n.postfix && ((t.height = (t.width / t.height) * n.value), (t.width = n.value)), (t.opts.srcset = s));
                            }
                            (t.$content = g('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(t.$slide.addClass("fancybox-slide--image"))),
                                (e = t.opts.thumb || (!(!t.opts.$thumb || !t.opts.$thumb.length) && t.opts.$thumb.attr("src"))),
                            !1 !== t.opts.preload &&
                            t.opts.width &&
                            t.opts.height &&
                            e &&
                            ((t.width = t.opts.width),
                                (t.height = t.opts.height),
                                (t.$ghost = g("<img />")
                                    .one("error", function () {
                                        g(this).remove(), (t.$ghost = null);
                                    })
                                    .one("load", function () {
                                        a.afterLoad(t);
                                    })
                                    .addClass("fancybox-image")
                                    .appendTo(t.$content)
                                    .attr("src", e))),
                                a.setBigImage(t);
                        },
                        setBigImage: function (t) {
                            var n = this,
                                i = g("<img />");
                            (t.$image = i
                                .one("error", function () {
                                    n.setError(t);
                                })
                                .one("load", function () {
                                    var e;
                                    t.$ghost || (n.resolveImageSlideSize(t, this.naturalWidth, this.naturalHeight), n.afterLoad(t)),
                                    t.timouts && (clearTimeout(t.timouts), (t.timouts = null)),
                                    n.isClosing ||
                                    (t.opts.srcset &&
                                    (((e = t.opts.sizes) && "auto" !== e) || (e = (1 < t.width / t.height && 1 < o.width() / o.height() ? "100" : Math.round((t.width / t.height) * 100)) + "vw"),
                                        i.attr("sizes", e).attr("srcset", t.opts.srcset)),
                                    t.$ghost &&
                                    setTimeout(function () {
                                        t.$ghost && !n.isClosing && t.$ghost.hide();
                                    }, Math.min(300, Math.max(1e3, t.height / 1600))),
                                        n.hideLoading(t));
                                })
                                .addClass("fancybox-image")
                                .attr("src", t.src)
                                .appendTo(t.$content)),
                                (i[0].complete || "complete" == i[0].readyState) && i[0].naturalWidth && i[0].naturalHeight ? i.trigger("load") : i[0].error && i.trigger("error");
                        },
                        resolveImageSlideSize: function (e, t, n) {
                            var i = parseInt(e.opts.width, 10),
                                o = parseInt(e.opts.height, 10);
                            (e.width = t), (e.height = n), 0 < i && ((e.width = i), (e.height = Math.floor((i * n) / t))), 0 < o && ((e.width = Math.floor((o * t) / n)), (e.height = o));
                        },
                        setIframe: function (o) {
                            var r,
                                t = this,
                                a = o.opts.iframe,
                                e = o.$slide;
                            (o.$content = g('<div class="fancybox-content' + (a.preload ? " fancybox-is-hidden" : "") + '"></div>')
                                .css(a.css)
                                .appendTo(e)),
                                e.addClass("fancybox-slide--" + o.contentType),
                                (o.$iframe = r = g(a.tpl.replace(/\{rnd\}/g, new Date().getTime()))
                                    .attr(a.attr)
                                    .appendTo(o.$content)),
                                a.preload
                                    ? (t.showLoading(o),
                                        r.on("load.fb error.fb", function (e) {
                                            (this.isReady = 1), o.$slide.trigger("refresh"), t.afterLoad(o);
                                        }),
                                        e.on("refresh.fb", function () {
                                            var e,
                                                t = o.$content,
                                                n = a.css.width,
                                                i = a.css.height;
                                            if (1 === r[0].isReady) {
                                                try {
                                                    e = r.contents().find("body");
                                                } catch (e) {}
                                                e &&
                                                e.length &&
                                                e.children().length &&
                                                (t.css({ width: "", height: "" }),
                                                n === b && (n = Math.ceil(Math.max(e[0].clientWidth, e.outerWidth(!0)))),
                                                n && t.width(n),
                                                i === b && (i = Math.ceil(Math.max(e[0].clientHeight, e.outerHeight(!0)))),
                                                i && t.height(i)),
                                                    t.removeClass("fancybox-is-hidden");
                                            }
                                        }))
                                    : this.afterLoad(o),
                                r.attr("src", o.src),
                                e.one("onReset", function () {
                                    try {
                                        g(this).find("iframe").hide().unbind().attr("src", "//about:blank");
                                    } catch (e) {}
                                    g(this).off("refresh.fb").empty(), (o.isLoaded = !1);
                                });
                        },
                        setContent: function (e, t) {
                            var n;
                            this.isClosing ||
                            (this.hideLoading(e),
                            e.$content && g.fancybox.stop(e.$content),
                                e.$slide.empty(),
                                (n = t) && n.hasOwnProperty && n instanceof g && t.parent().length
                                    ? (t.parent().parent(".fancybox-slide--inline").trigger("onReset"), (e.$placeholder = g("<div>").hide().insertAfter(t)), t.css("display", "inline-block"))
                                    : e.hasError || ("string" === g.type(t) && 3 === (t = g("<div>").append(g.trim(t)).contents())[0].nodeType && (t = g("<div>").html(t)), e.opts.filter && (t = g("<div>").html(t).find(e.opts.filter))),
                                e.$slide.one("onReset", function () {
                                    g(this).find("video,audio").trigger("pause"),
                                    e.$placeholder && (e.$placeholder.after(t.hide()).remove(), (e.$placeholder = null)),
                                    e.$smallBtn && (e.$smallBtn.remove(), (e.$smallBtn = null)),
                                    e.hasError || (g(this).empty(), (e.isLoaded = !1));
                                }),
                                g(t).appendTo(e.$slide),
                            g(t).is("video,audio") &&
                            (g(t).addClass("fancybox-video"), g(t).wrap("<div></div>"), (e.contentType = "video"), (e.opts.width = e.opts.width || g(t).attr("width")), (e.opts.height = e.opts.height || g(t).attr("height"))),
                                (e.$content = e.$slide.children().filter("div,form,main,video,audio").first().addClass("fancybox-content")),
                                e.$slide.addClass("fancybox-slide--" + e.contentType),
                                this.afterLoad(e));
                        },
                        setError: function (e) {
                            (e.hasError = !0),
                                e.$slide
                                    .trigger("onReset")
                                    .removeClass("fancybox-slide--" + e.contentType)
                                    .addClass("fancybox-slide--error"),
                                (e.contentType = "html"),
                                this.setContent(e, this.translate(e, e.opts.errorTpl)),
                            e.pos === this.currPos && (this.isAnimating = !1);
                        },
                        showLoading: function (e) {
                            (e = e || this.current) && !e.$spinner && (e.$spinner = g(this.translate(this, this.opts.spinnerTpl)).appendTo(e.$slide));
                        },
                        hideLoading: function (e) {
                            (e = e || this.current) && e.$spinner && (e.$spinner.remove(), delete e.$spinner);
                        },
                        afterLoad: function (e) {
                            var t = this;
                            t.isClosing ||
                            ((e.isLoading = !1),
                                (e.isLoaded = !0),
                                t.trigger("afterLoad", e),
                                t.hideLoading(e),
                            e.pos === t.currPos && t.updateCursor(),
                            !e.opts.smallBtn || (e.$smallBtn && e.$smallBtn.length) || (e.$smallBtn = g(t.translate(e, e.opts.btnTpl.smallBtn)).prependTo(e.$content)),
                            e.opts.protect &&
                            e.$content &&
                            !e.hasError &&
                            (e.$content.on("contextmenu.fb", function (e) {
                                return 2 == e.button && e.preventDefault(), !0;
                            }),
                            "image" === e.type && g('<div class="fancybox-spaceball"></div>').appendTo(e.$content)),
                                t.revealContent(e));
                        },
                        revealContent: function (t) {
                            var e,
                                n,
                                i,
                                o,
                                r = this,
                                a = t.$slide,
                                s = !1,
                                l = !1;
                            return (
                                (e = t.opts[r.firstRun ? "animationEffect" : "transitionEffect"]),
                                    (i = t.opts[r.firstRun ? "animationDuration" : "transitionDuration"]),
                                    (i = parseInt(t.forcedDuration === b ? i : t.forcedDuration, 10)),
                                t.pos === r.currPos && (t.isComplete ? (e = !1) : (r.isAnimating = !0)),
                                (!t.isMoved && t.pos === r.currPos && i) || (e = !1),
                                "zoom" === e && (t.pos === r.currPos && i && "image" === t.type && !t.hasError && (l = r.getThumbPos(t)) ? (s = r.getFitPos(t)) : (e = "fade")),
                                    "zoom" === e
                                        ? ((s.scaleX = s.width / l.width),
                                            (s.scaleY = s.height / l.height),
                                        "auto" == (o = t.opts.zoomOpacity) && (o = 0.1 < Math.abs(t.width / t.height - l.width / l.height)),
                                        o && ((l.opacity = 0.1), (s.opacity = 1)),
                                            g.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"), l),
                                            void g.fancybox.animate(t.$content, s, i, function () {
                                                (r.isAnimating = !1), r.complete();
                                            }))
                                        : (r.updateSlide(t),
                                            e
                                                ? (g.fancybox.stop(a),
                                                    (n = "fancybox-animated fancybox-slide--" + (t.pos >= r.prevPos ? "next" : "previous") + " fancybox-fx-" + e),
                                                    a.removeAttr("style").removeClass("fancybox-slide--current fancybox-slide--next fancybox-slide--previous").addClass(n),
                                                    t.$content.removeClass("fancybox-is-hidden"),
                                                    void g.fancybox.animate(
                                                        a,
                                                        "fancybox-slide--current",
                                                        i,
                                                        function (e) {
                                                            a.removeClass(n).removeAttr("style"), t.pos === r.currPos && r.complete();
                                                        },
                                                        !0
                                                    ))
                                                : (t.$content.removeClass("fancybox-is-hidden"), void (t.pos === r.currPos && r.complete())))
                            );
                        },
                        getThumbPos: function (e) {
                            var t,
                                n = !1,
                                i = e.opts.$thumb,
                                o = i && i.length && i[0].ownerDocument === a ? i.offset() : 0;
                            return (
                                o &&
                                (function (e) {
                                    for (var t = e[0], i = t.getBoundingClientRect(), n = []; null !== t.parentElement; )
                                        ("hidden" !== g(t.parentElement).css("overflow") && "auto" !== g(t.parentElement).css("overflow")) || n.push(t.parentElement.getBoundingClientRect()), (t = t.parentElement);
                                    return (
                                        n.every(function (e) {
                                            var t = Math.min(i.right, e.right) - Math.max(i.left, e.left),
                                                n = Math.min(i.bottom, e.bottom) - Math.max(i.top, e.top);
                                            return 0 < t && 0 < n;
                                        }) &&
                                        0 < i.bottom &&
                                        0 < i.right &&
                                        i.left < g(u).width() &&
                                        i.top < g(u).height()
                                    );
                                })(i) &&
                                ((t = this.$refs.stage.offset()),
                                    (n = { top: o.top - t.top + parseFloat(i.css("border-top-width") || 0), left: o.left - t.left + parseFloat(i.css("border-left-width") || 0), width: i.width(), height: i.height(), scaleX: 1, scaleY: 1 })),
                                    n
                            );
                        },
                        complete: function () {
                            var n = this,
                                e = n.current,
                                i = {};
                            !e.isMoved &&
                            e.isLoaded &&
                            (e.isComplete ||
                            ((e.isComplete = !0),
                                e.$slide.siblings().trigger("onReset"),
                                n.preload("inline"),
                                e.$slide.addClass("fancybox-slide--complete"),
                                g.each(n.slides, function (e, t) {
                                    t.pos >= n.currPos - 1 && t.pos <= n.currPos + 1 ? (i[t.pos] = t) : t && (g.fancybox.stop(t.$slide), t.$slide.off().remove());
                                }),
                                (n.slides = i)),
                                (n.isAnimating = !1),
                                n.updateCursor(),
                                n.trigger("afterShow"),
                                e.$slide.find("video,audio").filter(":visible:first").trigger("play"),
                            (g(a.activeElement).is("[disabled]") || (e.opts.autoFocus && "image" != e.type && "iframe" !== e.type)) && n.focus());
                        },
                        preload: function (e) {
                            var t = this,
                                n = t.slides[t.currPos + 1],
                                i = t.slides[t.currPos - 1];
                            n && n.type === e && t.loadSlide(n), i && i.type === e && t.loadSlide(i);
                        },
                        focus: function () {
                            var e,
                                t = this.current;
                            this.isClosing ||
                            (t &&
                                t.isComplete &&
                                t.$content &&
                                ((e = t.$content.find("input[autofocus]:enabled:visible:first")).length || (e = t.$content.find("button,:input,[tabindex],a").filter(":enabled:visible:first")),
                                    (e = e && e.length ? e : t.$content).trigger("focus")));
                        },
                        activate: function () {
                            var t = this;
                            g(".fancybox-container").each(function () {
                                var e = g(this).data("FancyBox");
                                e && e.id !== t.id && !e.isClosing && (e.trigger("onDeactivate"), e.removeEvents(), (e.isVisible = !1));
                            }),
                                (t.isVisible = !0),
                            (t.current || t.isIdle) && (t.update(), t.updateControls()),
                                t.trigger("onActivate"),
                                t.addEvents();
                        },
                        close: function (e, t) {
                            var n,
                                i,
                                o,
                                r,
                                a,
                                s,
                                l,
                                c = this,
                                u = c.current,
                                d = function () {
                                    c.cleanUp(e);
                                };
                            return (
                                !c.isClosing &&
                                (!(c.isClosing = !0) === c.trigger("beforeClose", e)
                                    ? ((c.isClosing = !1),
                                        f(function () {
                                            c.update();
                                        }),
                                        !1)
                                    : (c.removeEvents(),
                                    u.timouts && clearTimeout(u.timouts),
                                        (o = u.$content),
                                        (n = u.opts.animationEffect),
                                        (i = g.isNumeric(t) ? t : n ? u.opts.animationDuration : 0),
                                        u.$slide.off(p).removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"),
                                        u.$slide.siblings().trigger("onReset").remove(),
                                    i && c.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing"),
                                        c.hideLoading(u),
                                        c.hideControls(),
                                        c.updateCursor(),
                                    "zoom" !== n || (!0 !== e && o && i && "image" === u.type && !u.hasError && (l = c.getThumbPos(u))) || (n = "fade"),
                                        "zoom" === n
                                            ? (g.fancybox.stop(o),
                                                (s = { top: (r = g.fancybox.getTranslate(o)).top, left: r.left, scaleX: r.width / l.width, scaleY: r.height / l.height, width: l.width, height: l.height }),
                                            "auto" == (a = u.opts.zoomOpacity) && (a = 0.1 < Math.abs(u.width / u.height - l.width / l.height)),
                                            a && (l.opacity = 0),
                                                g.fancybox.setTranslate(o, s),
                                                g.fancybox.animate(o, l, i, d))
                                            : n && i
                                                ? !0 === e
                                                    ? setTimeout(d, i)
                                                    : g.fancybox.animate(u.$slide.removeClass("fancybox-slide--current"), "fancybox-animated fancybox-slide--previous fancybox-fx-" + n, i, d)
                                                : d(),
                                        !0))
                            );
                        },
                        cleanUp: function (e) {
                            var t,
                                n = this,
                                i = g("body");
                            n.current.$slide.trigger("onReset"),
                                n.$refs.container.empty().remove(),
                                n.trigger("afterClose", e),
                            n.$lastFocus && n.current.opts.backFocus && n.$lastFocus.trigger("focus"),
                                (n.current = null),
                                (t = g.fancybox.getInstance()) ? t.activate() : (i.removeClass("fancybox-active compensate-for-scrollbar"), g("#fancybox-style-noscroll").remove());
                        },
                        trigger: function (e, t) {
                            var n,
                                i = Array.prototype.slice.call(arguments, 1),
                                o = this,
                                r = t && t.opts ? t : o.current;
                            if ((r ? i.unshift(r) : (r = o), i.unshift(o), g.isFunction(r.opts[e]) && (n = r.opts[e].apply(r, i)), !1 === n)) return n;
                            "afterClose" !== e && o.$refs ? o.$refs.container.trigger(e + ".fb", i) : s.trigger(e + ".fb", i);
                        },
                        updateControls: function (e) {
                            var t = this,
                                n = t.current,
                                i = n.index,
                                o = n.opts.caption,
                                r = t.$refs.container,
                                a = t.$refs.caption;
                            n.$slide.trigger("refresh"),
                                (t.$caption = o && o.length ? a.html(o) : null),
                            t.isHiddenControls || t.isIdle || t.showControls(),
                                r.find("[data-fancybox-count]").html(t.group.length),
                                r.find("[data-fancybox-index]").html(i + 1),
                                r.find("[data-fancybox-prev]").toggleClass("disabled", !n.opts.loop && i <= 0),
                                r.find("[data-fancybox-next]").toggleClass("disabled", !n.opts.loop && i >= t.group.length - 1),
                                "image" === n.type
                                    ? r
                                        .find("[data-fancybox-zoom]")
                                        .show()
                                        .end()
                                        .find("[data-fancybox-download]")
                                        .attr("href", n.opts.image.src || n.src)
                                        .show()
                                    : n.opts.toolbar && r.find("[data-fancybox-download],[data-fancybox-zoom]").hide();
                        },
                        hideControls: function () {
                            (this.isHiddenControls = !0), this.$refs.container.removeClass("fancybox-show-infobar fancybox-show-toolbar fancybox-show-caption fancybox-show-nav");
                        },
                        showControls: function () {
                            var e = this,
                                t = e.current ? e.current.opts : e.opts,
                                n = e.$refs.container;
                            (e.isHiddenControls = !1),
                                (e.idleSecondsCounter = 0),
                                n
                                    .toggleClass("fancybox-show-toolbar", !(!t.toolbar || !t.buttons))
                                    .toggleClass("fancybox-show-infobar", !!(t.infobar && 1 < e.group.length))
                                    .toggleClass("fancybox-show-nav", !!(t.arrows && 1 < e.group.length))
                                    .toggleClass("fancybox-is-modal", !!t.modal),
                                e.$caption ? n.addClass("fancybox-show-caption ") : n.removeClass("fancybox-show-caption");
                        },
                        toggleControls: function () {
                            this.isHiddenControls ? this.showControls() : this.hideControls();
                        },
                    }),
                        (g.fancybox = {
                            version: "3.3.5",
                            defaults: t,
                            getInstance: function (e) {
                                var t = g('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"),
                                    n = Array.prototype.slice.call(arguments, 1);
                                return t instanceof i && ("string" === g.type(e) ? t[e].apply(t, n) : "function" === g.type(e) && e.apply(t, n), t);
                            },
                            open: function (e, t, n) {
                                return new i(e, t, n);
                            },
                            close: function (e) {
                                var t = this.getInstance();
                                t && (t.close(), !0 === e && this.close());
                            },
                            destroy: function () {
                                this.close(!0), s.add("body").off("click.fb-start", "**");
                            },
                            isMobile: a.createTouch !== b && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                            use3d: ((e = a.createElement("div")), u.getComputedStyle && u.getComputedStyle(e) && u.getComputedStyle(e).getPropertyValue("transform") && !(a.documentMode && a.documentMode < 11)),
                            getTranslate: function (e) {
                                var t;
                                return !(!e || !e.length) && { top: (t = e[0].getBoundingClientRect()).top || 0, left: t.left || 0, width: t.width, height: t.height, opacity: parseFloat(e.css("opacity")) };
                            },
                            setTranslate: function (e, t) {
                                var n = "",
                                    i = {};
                                if (e && t)
                                    return (
                                        (t.left === b && t.top === b) ||
                                        ((n = (t.left === b ? e.position().left : t.left) + "px, " + (t.top === b ? e.position().top : t.top) + "px"), (n = this.use3d ? "translate3d(" + n + ", 0px)" : "translate(" + n + ")")),
                                        t.scaleX !== b && t.scaleY !== b && (n = (n.length ? n + " " : "") + "scale(" + t.scaleX + ", " + t.scaleY + ")"),
                                        n.length && (i.transform = n),
                                        t.opacity !== b && (i.opacity = t.opacity),
                                        t.width !== b && (i.width = t.width),
                                        t.height !== b && (i.height = t.height),
                                            e.css(i)
                                    );
                            },
                            animate: function (t, n, e, i, o) {
                                var r = !1;
                                g.isFunction(e) && ((i = e), (e = null)),
                                g.isPlainObject(n) || t.removeAttr("style"),
                                    g.fancybox.stop(t),
                                    t.on(p, function (e) {
                                        (!e || !e.originalEvent || (t.is(e.originalEvent.target) && "z-index" != e.originalEvent.propertyName)) &&
                                        (g.fancybox.stop(t), r && g.fancybox.setTranslate(t, r), g.isPlainObject(n) ? !1 === o && t.removeAttr("style") : !0 !== o && t.removeClass(n), g.isFunction(i) && i(e));
                                    }),
                                g.isNumeric(e) && t.css("transition-duration", e + "ms"),
                                    g.isPlainObject(n)
                                        ? (n.scaleX !== b &&
                                        n.scaleY !== b &&
                                        ((r = g.extend({}, n, { width: t.width() * n.scaleX, height: t.height() * n.scaleY, scaleX: 1, scaleY: 1 })),
                                            delete n.width,
                                            delete n.height,
                                        t.parent().hasClass("fancybox-slide--image") && t.parent().addClass("fancybox-is-scaling")),
                                            g.fancybox.setTranslate(t, n))
                                        : t.addClass(n),
                                    t.data(
                                        "timer",
                                        setTimeout(function () {
                                            t.trigger("transitionend");
                                        }, e + 16)
                                    );
                            },
                            stop: function (e) {
                                e && e.length && (clearTimeout(e.data("timer")), e.off("transitionend").css("transition-duration", ""), e.parent().removeClass("fancybox-is-scaling"));
                            },
                        }),
                        (g.fn.fancybox = function (e) {
                            var t;
                            return (t = (e = e || {}).selector || !1) ? g("body").off("click.fb-start", t).on("click.fb-start", t, { options: e }, n) : this.off("click.fb-start").on("click.fb-start", { items: this, options: e }, n), this;
                        }),
                        s.on("click.fb-start", "[data-fancybox]", n),
                        s.on("click.fb-start", "[data-trigger]", function (e) {
                            n(e, { $target: g('[data-fancybox="' + g(e.currentTarget).attr("data-trigger") + '"]').eq(g(e.currentTarget).attr("data-index") || 0), $trigger: g(this) });
                        });
                }
            function n(e, t) {
                var n,
                    i,
                    o = [],
                    r = 0;
                (e && e.isDefaultPrevented()) ||
                (e.preventDefault(),
                    (i = (n = (t = e && e.data ? e.data.options : t || {}).$target || g(e.currentTarget)).attr("data-fancybox") || "")
                        ? (r = (o = (o = t.selector ? g(t.selector) : e.data ? e.data.items : []).length ? o.filter('[data-fancybox="' + i + '"]') : g('[data-fancybox="' + i + '"]')).index(n)) < 0 && (r = 0)
                        : (o = [n]),
                    g.fancybox.open(o, t, r));
            }
        })(window, document, window.jQuery || jQuery),
        (p = window.jQuery || jQuery),
        (h = function (n, e, t) {
            if (n)
                return (
                    (t = t || ""),
                    "object" === p.type(t) && (t = p.param(t, !0)),
                        p.each(e, function (e, t) {
                            n = n.replace("$" + e, t || "");
                        }),
                    t.length && (n += (0 < n.indexOf("?") ? "&" : "?") + t),
                        n
                );
        }),
        (g = {
            youtube: {
                matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
                params: { autoplay: 1, autohide: 1, fs: 1, rel: 0, hd: 1, wmode: "transparent", enablejsapi: 1, html5: 1 },
                paramPlace: 8,
                type: "iframe",
                url: "//www.youtube.com/embed/$4",
                thumb: "//img.youtube.com/vi/$4/hqdefault.jpg",
            },
            vimeo: { matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/, params: { autoplay: 1, hd: 1, show_title: 1, show_byline: 1, show_portrait: 0, fullscreen: 1, api: 1 }, paramPlace: 3, type: "iframe", url: "//player.vimeo.com/video/$2" },
            instagram: { matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i, type: "image", url: "//$1/p/$2/media/?size=l" },
            gmap_place: {
                matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
                type: "iframe",
                url: function (e) {
                    return (
                        "//maps.google." +
                        e[2] +
                        "/?ll=" +
                        (e[9] ? e[9] + "&z=" + Math.floor(e[10]) + (e[12] ? e[12].replace(/^\//, "&") : "") : e[12] + "").replace(/\?/, "&") +
                        "&output=" +
                        (e[12] && 0 < e[12].indexOf("layer=c") ? "svembed" : "embed")
                    );
                },
            },
            gmap_search: {
                matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
                type: "iframe",
                url: function (e) {
                    return "//maps.google." + e[2] + "/maps?q=" + e[5].replace("query=", "q=").replace("api=1", "") + "&output=embed";
                },
            },
        }),
        p(document).on("objectNeedsType.fb", function (e, t, o) {
            var n,
                r,
                a,
                s,
                l,
                c,
                u,
                d = o.src || "",
                f = !1;
            (n = p.extend(!0, {}, g, o.opts.media)),
                p.each(n, function (e, t) {
                    if ((a = d.match(t.matcher))) {
                        if (((f = t.type), (u = e), (c = {}), t.paramPlace && a[t.paramPlace])) {
                            "?" == (l = a[t.paramPlace])[0] && (l = l.substring(1)), (l = l.split("&"));
                            for (var n = 0; n < l.length; ++n) {
                                var i = l[n].split("=", 2);
                                2 == i.length && (c[i[0]] = decodeURIComponent(i[1].replace(/\+/g, " ")));
                            }
                        }
                        return (
                            (s = p.extend(!0, {}, t.params, o.opts[e], c)),
                                (d = "function" === p.type(t.url) ? t.url.call(this, a, s, o) : h(t.url, a, s)),
                                (r = "function" === p.type(t.thumb) ? t.thumb.call(this, a, s, o) : h(t.thumb, a)),
                                "youtube" === e
                                    ? (d = d.replace(/&t=((\d+)m)?(\d+)s/, function (e, t, n, i) {
                                        return "&start=" + ((n ? 60 * parseInt(n, 10) : 0) + parseInt(i, 10));
                                    }))
                                    : "vimeo" === e && (d = d.replace("&%23", "#")),
                                !1
                        );
                    }
                }),
                f
                    ? (o.opts.thumb || (o.opts.$thumb && o.opts.$thumb.length) || (o.opts.thumb = r),
                    "iframe" === f && (o.opts = p.extend(!0, o.opts, { iframe: { preload: !1, attr: { scrolling: "no" } } })),
                        p.extend(o, { type: f, src: d, origSrc: o.src, contentSource: u, contentType: "image" === f ? "image" : "gmap_place" == u || "gmap_search" == u ? "map" : "video" }))
                    : d && (o.type = o.opts.defaultType);
        }),
        (b = window),
        (s = document),
        (m = window.jQuery || jQuery),
        (T =
            b.requestAnimationFrame ||
            b.webkitRequestAnimationFrame ||
            b.mozRequestAnimationFrame ||
            b.oRequestAnimationFrame ||
            function (e) {
                return b.setTimeout(e, 1e3 / 60);
            }),
        (v =
            b.cancelAnimationFrame ||
            b.webkitCancelAnimationFrame ||
            b.mozCancelAnimationFrame ||
            b.oCancelAnimationFrame ||
            function (e) {
                b.clearTimeout(e);
            }),
        (u = function (e) {
            var t = [];
            for (var n in (e = (e = e.originalEvent || e || b.e).touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [e]))
                e[n].pageX ? t.push({ x: e[n].pageX, y: e[n].pageY }) : e[n].clientX && t.push({ x: e[n].clientX, y: e[n].clientY });
            return t;
        }),
        (y = function (e, t, n) {
            return t && e ? ("x" === n ? e.x - t.x : "y" === n ? e.y - t.y : Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))) : 0;
        }),
        (l = function (e) {
            if (e.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio') || m.isFunction(e.get(0).onclick) || e.data("selectable")) return !0;
            for (var t = 0, n = e[0].attributes, i = n.length; t < i; t++) if ("data-fancybox-" === n[t].nodeName.substr(0, 14)) return !0;
            return !1;
        }),
        (c = function (e) {
            for (
                var t, n, i, o, r, a = !1;
                (t = e.get(0)),
                    void 0,
                    (n = b.getComputedStyle(t)["overflow-y"]),
                    (i = b.getComputedStyle(t)["overflow-x"]),
                    (o = ("scroll" === n || "auto" === n) && t.scrollHeight > t.clientHeight),
                    (r = ("scroll" === i || "auto" === i) && t.scrollWidth > t.clientWidth),
                !(a = o || r) && (e = e.parent()).length && !e.hasClass("fancybox-stage") && !e.is("body");

            );
            return a;
        }),
        ((n = function (e) {
            var t = this;
            (t.instance = e), (t.$bg = e.$refs.bg), (t.$stage = e.$refs.stage), (t.$container = e.$refs.container), t.destroy(), t.$container.on("touchstart.fb.touch mousedown.fb.touch", m.proxy(t, "ontouchstart"));
        }).prototype.destroy = function () {
            this.$container.off(".fb.touch");
        }),
        (n.prototype.ontouchstart = function (e) {
            var t = this,
                n = m(e.target),
                i = t.instance,
                o = i.current,
                r = o.$content,
                a = "touchstart" == e.type;
            if ((a && t.$container.off("mousedown.fb.touch"), (!e.originalEvent || 2 != e.originalEvent.button) && n.length && !l(n) && !l(n.parent()) && (n.is("img") || !(e.originalEvent.clientX > n[0].clientWidth + n.offset().left)))) {
                if (!o || i.isAnimating || i.isClosing) return e.stopPropagation(), void e.preventDefault();
                (t.realPoints = t.startPoints = u(e)),
                t.startPoints.length &&
                (e.stopPropagation(),
                    (t.startEvent = e),
                    (t.canTap = !0),
                    (t.$target = n),
                    (t.$content = r),
                    (t.opts = o.opts.touch),
                    (t.isPanning = !1),
                    (t.isSwiping = !1),
                    (t.isZooming = !1),
                    (t.isScrolling = !1),
                    (t.startTime = new Date().getTime()),
                    (t.distanceX = t.distanceY = t.distance = 0),
                    (t.canvasWidth = Math.round(o.$slide[0].clientWidth)),
                    (t.canvasHeight = Math.round(o.$slide[0].clientHeight)),
                    (t.contentLastPos = null),
                    (t.contentStartPos = m.fancybox.getTranslate(t.$content) || { top: 0, left: 0 }),
                    (t.sliderStartPos = t.sliderLastPos || m.fancybox.getTranslate(o.$slide)),
                    (t.stagePos = m.fancybox.getTranslate(i.$refs.stage)),
                    (t.sliderStartPos.top -= t.stagePos.top),
                    (t.sliderStartPos.left -= t.stagePos.left),
                    (t.contentStartPos.top -= t.stagePos.top),
                    (t.contentStartPos.left -= t.stagePos.left),
                    m(s)
                        .off(".fb.touch")
                        .on(a ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", m.proxy(t, "ontouchend"))
                        .on(a ? "touchmove.fb.touch" : "mousemove.fb.touch", m.proxy(t, "ontouchmove")),
                m.fancybox.isMobile && s.addEventListener("scroll", t.onscroll, !0),
                    (t.opts || i.canPan()) && (n.is(t.$stage) || t.$stage.find(n).length)
                        ? ((m.fancybox.isMobile && (c(n) || c(n.parent()))) || e.preventDefault(),
                        (1 === t.startPoints.length || o.hasError) &&
                        (t.instance.canPan() ? (m.fancybox.stop(t.$content), t.$content.css("transition-duration", ""), (t.isPanning = !0)) : (t.isSwiping = !0), t.$container.addClass("fancybox-controls--isGrabbing")),
                        2 === t.startPoints.length &&
                        "image" === o.type &&
                        (o.isLoaded || o.$ghost) &&
                        ((t.canTap = !1),
                            (t.isSwiping = !1),
                            (t.isPanning = !1),
                            (t.isZooming = !0),
                            m.fancybox.stop(t.$content),
                            t.$content.css("transition-duration", ""),
                            (t.centerPointStartX = 0.5 * (t.startPoints[0].x + t.startPoints[1].x) - m(b).scrollLeft()),
                            (t.centerPointStartY = 0.5 * (t.startPoints[0].y + t.startPoints[1].y) - m(b).scrollTop()),
                            (t.percentageOfImageAtPinchPointX = (t.centerPointStartX - t.contentStartPos.left) / t.contentStartPos.width),
                            (t.percentageOfImageAtPinchPointY = (t.centerPointStartY - t.contentStartPos.top) / t.contentStartPos.height),
                            (t.startDistanceBetweenFingers = y(t.startPoints[0], t.startPoints[1]))))
                        : n.is(".fancybox-image") && e.preventDefault());
            }
        }),
        (n.prototype.onscroll = function (e) {
            (this.isScrolling = !0), s.removeEventListener("scroll", this.onscroll, !0);
        }),
        (n.prototype.ontouchmove = function (e) {
            var t = this,
                n = m(e.target);
            void 0 === e.originalEvent.buttons || 0 !== e.originalEvent.buttons
                ? t.isScrolling || (!n.is(t.$stage) && !t.$stage.find(n).length)
                    ? (t.canTap = !1)
                    : ((t.newPoints = u(e)),
                    (t.opts || t.instance.canPan()) &&
                    t.newPoints.length &&
                    t.newPoints.length &&
                    ((t.isSwiping && !0 === t.isSwiping) || e.preventDefault(),
                        (t.distanceX = y(t.newPoints[0], t.startPoints[0], "x")),
                        (t.distanceY = y(t.newPoints[0], t.startPoints[0], "y")),
                        (t.distance = y(t.newPoints[0], t.startPoints[0])),
                    0 < t.distance && (t.isSwiping ? t.onSwipe(e) : t.isPanning ? t.onPan() : t.isZooming && t.onZoom())))
                : t.ontouchend(e);
        }),
        (n.prototype.onSwipe = function (e) {
            var t,
                i = this,
                n = i.isSwiping,
                o = i.sliderStartPos.left || 0;
            if (!0 !== n)
                "x" == n &&
                (0 < i.distanceX && (i.instance.group.length < 2 || (0 === i.instance.current.index && !i.instance.current.opts.loop))
                    ? (o += Math.pow(i.distanceX, 0.8))
                    : i.distanceX < 0 && (i.instance.group.length < 2 || (i.instance.current.index === i.instance.group.length - 1 && !i.instance.current.opts.loop))
                        ? (o -= Math.pow(-i.distanceX, 0.8))
                        : (o += i.distanceX)),
                    (i.sliderLastPos = { top: "x" == n ? 0 : i.sliderStartPos.top + i.distanceY, left: o }),
                i.requestId && (v(i.requestId), (i.requestId = null)),
                    (i.requestId = T(function () {
                        i.sliderLastPos &&
                        (m.each(i.instance.slides, function (e, t) {
                            var n = t.pos - i.instance.currPos;
                            m.fancybox.setTranslate(t.$slide, { top: i.sliderLastPos.top, left: i.sliderLastPos.left + n * i.canvasWidth + n * t.opts.gutter });
                        }),
                            i.$container.addClass("fancybox-is-sliding"));
                    }));
            else if (10 < Math.abs(i.distance)) {
                if (
                    ((i.canTap = !1),
                        i.instance.group.length < 2 && i.opts.vertical
                            ? (i.isSwiping = "y")
                            : i.instance.isDragging || !1 === i.opts.vertical || ("auto" === i.opts.vertical && 800 < m(b).width())
                                ? (i.isSwiping = "x")
                                : ((t = Math.abs((180 * Math.atan2(i.distanceY, i.distanceX)) / Math.PI)), (i.isSwiping = 45 < t && t < 135 ? "y" : "x")),
                        (i.canTap = !1),
                    "y" === i.isSwiping && m.fancybox.isMobile && (c(i.$target) || c(i.$target.parent())))
                )
                    return void (i.isScrolling = !0);
                (i.instance.isDragging = i.isSwiping),
                    (i.startPoints = i.newPoints),
                    m.each(i.instance.slides, function (e, t) {
                        m.fancybox.stop(t.$slide),
                            t.$slide.css("transition-duration", ""),
                            (t.inTransition = !1),
                        t.pos === i.instance.current.pos && (i.sliderStartPos.left = m.fancybox.getTranslate(t.$slide).left - m.fancybox.getTranslate(i.instance.$refs.stage).left);
                    }),
                i.instance.SlideShow && i.instance.SlideShow.isActive && i.instance.SlideShow.stop();
            }
        }),
        (n.prototype.onPan = function () {
            var e = this;
            y(e.newPoints[0], e.realPoints[0]) < (m.fancybox.isMobile ? 10 : 5)
                ? (e.startPoints = e.newPoints)
                : ((e.canTap = !1),
                    (e.contentLastPos = e.limitMovement()),
                e.requestId && (v(e.requestId), (e.requestId = null)),
                    (e.requestId = T(function () {
                        m.fancybox.setTranslate(e.$content, e.contentLastPos);
                    })));
        }),
        (n.prototype.limitMovement = function () {
            var e,
                t,
                n,
                i,
                o,
                r,
                a = this,
                s = a.canvasWidth,
                l = a.canvasHeight,
                c = a.distanceX,
                u = a.distanceY,
                d = a.contentStartPos,
                f = d.left,
                p = d.top,
                h = d.width,
                g = d.height;
            return (
                (o = s < h ? f + c : f),
                    (r = p + u),
                    (e = Math.max(0, 0.5 * s - 0.5 * h)),
                    (t = Math.max(0, 0.5 * l - 0.5 * g)),
                    (n = Math.min(s - h, 0.5 * s - 0.5 * h)),
                    (i = Math.min(l - g, 0.5 * l - 0.5 * g)),
                0 < c && e < o && (o = e - 1 + Math.pow(-e + f + c, 0.8) || 0),
                c < 0 && o < n && (o = n + 1 - Math.pow(n - f - c, 0.8) || 0),
                0 < u && t < r && (r = t - 1 + Math.pow(-t + p + u, 0.8) || 0),
                u < 0 && r < i && (r = i + 1 - Math.pow(i - p - u, 0.8) || 0),
                    { top: r, left: o }
            );
        }),
        (n.prototype.limitPosition = function (e, t, n, i) {
            var o = this.canvasWidth,
                r = this.canvasHeight;
            return (e = o < n ? ((e = 0 < e ? 0 : e) < o - n ? o - n : e) : Math.max(0, o / 2 - n / 2)), { top: (t = r < i ? ((t = 0 < t ? 0 : t) < r - i ? r - i : t) : Math.max(0, r / 2 - i / 2)), left: e };
        }),
        (n.prototype.onZoom = function () {
            var e = this,
                t = e.contentStartPos,
                n = t.width,
                i = t.height,
                o = t.left,
                r = t.top,
                a = y(e.newPoints[0], e.newPoints[1]) / e.startDistanceBetweenFingers,
                s = Math.floor(n * a),
                l = Math.floor(i * a),
                c = (n - s) * e.percentageOfImageAtPinchPointX,
                u = (i - l) * e.percentageOfImageAtPinchPointY,
                d = (e.newPoints[0].x + e.newPoints[1].x) / 2 - m(b).scrollLeft(),
                f = (e.newPoints[0].y + e.newPoints[1].y) / 2 - m(b).scrollTop(),
                p = d - e.centerPointStartX,
                h = { top: r + (u + (f - e.centerPointStartY)), left: o + (c + p), scaleX: a, scaleY: a };
            (e.canTap = !1),
                (e.newWidth = s),
                (e.newHeight = l),
                (e.contentLastPos = h),
            e.requestId && (v(e.requestId), (e.requestId = null)),
                (e.requestId = T(function () {
                    m.fancybox.setTranslate(e.$content, e.contentLastPos);
                }));
        }),
        (n.prototype.ontouchend = function (e) {
            var t = this,
                n = Math.max(new Date().getTime() - t.startTime, 1),
                i = t.isSwiping,
                o = t.isPanning,
                r = t.isZooming,
                a = t.isScrolling;
            if (
                ((t.endPoints = u(e)),
                    t.$container.removeClass("fancybox-controls--isGrabbing"),
                    m(s).off(".fb.touch"),
                    s.removeEventListener("scroll", t.onscroll, !0),
                t.requestId && (v(t.requestId), (t.requestId = null)),
                    (t.isSwiping = !1),
                    (t.isPanning = !1),
                    (t.isZooming = !1),
                    (t.isScrolling = !1),
                    (t.instance.isDragging = !1),
                    t.canTap)
            )
                return t.onTap(e);
            (t.speed = 366),
                (t.velocityX = (t.distanceX / n) * 0.5),
                (t.velocityY = (t.distanceY / n) * 0.5),
                (t.speedX = Math.max(0.5 * t.speed, Math.min(1.5 * t.speed, (1 / Math.abs(t.velocityX)) * t.speed))),
                o ? t.endPanning() : r ? t.endZooming() : t.endSwiping(i, a);
        }),
        (n.prototype.endSwiping = function (e, t) {
            var n = this,
                i = !1,
                o = n.instance.group.length;
            (n.sliderLastPos = null),
                "y" == e && !t && 50 < Math.abs(n.distanceY)
                    ? (m.fancybox.animate(n.instance.current.$slide, { top: n.sliderStartPos.top + n.distanceY + 150 * n.velocityY, opacity: 0 }, 200), (i = n.instance.close(!0, 200)))
                    : "x" == e && 50 < n.distanceX && 1 < o
                        ? (i = n.instance.previous(n.speedX))
                        : "x" == e && n.distanceX < -50 && 1 < o && (i = n.instance.next(n.speedX)),
            !1 !== i || ("x" != e && "y" != e) || (t || o < 2 ? n.instance.centerSlide(n.instance.current, 150) : n.instance.jumpTo(n.instance.current.index)),
                n.$container.removeClass("fancybox-is-sliding");
        }),
        (n.prototype.endPanning = function () {
            var e,
                t,
                n,
                i = this;
            i.contentLastPos &&
            (!1 === i.opts.momentum ? ((e = i.contentLastPos.left), (t = i.contentLastPos.top)) : ((e = i.contentLastPos.left + i.velocityX * i.speed), (t = i.contentLastPos.top + i.velocityY * i.speed)),
                ((n = i.limitPosition(e, t, i.contentStartPos.width, i.contentStartPos.height)).width = i.contentStartPos.width),
                (n.height = i.contentStartPos.height),
                m.fancybox.animate(i.$content, n, 330));
        }),
        (n.prototype.endZooming = function () {
            var e,
                t,
                n,
                i,
                o = this,
                r = o.instance.current,
                a = o.newWidth,
                s = o.newHeight;
            o.contentLastPos &&
            ((e = o.contentLastPos.left),
                (i = { top: (t = o.contentLastPos.top), left: e, width: a, height: s, scaleX: 1, scaleY: 1 }),
                m.fancybox.setTranslate(o.$content, i),
                a < o.canvasWidth && s < o.canvasHeight
                    ? o.instance.scaleToFit(150)
                    : a > r.width || s > r.height
                        ? o.instance.scaleToActual(o.centerPointStartX, o.centerPointStartY, 150)
                        : ((n = o.limitPosition(e, t, a, s)), m.fancybox.setTranslate(o.$content, m.fancybox.getTranslate(o.$content)), m.fancybox.animate(o.$content, n, 150)));
        }),
        (n.prototype.onTap = function (n) {
            var e,
                i = this,
                t = m(n.target),
                o = i.instance,
                r = o.current,
                a = (n && u(n)) || i.startPoints,
                s = a[0] ? a[0].x - m(b).scrollLeft() - i.stagePos.left : 0,
                l = a[0] ? a[0].y - m(b).scrollTop() - i.stagePos.top : 0,
                c = function (e) {
                    var t = r.opts[e];
                    if ((m.isFunction(t) && (t = t.apply(o, [r, n])), t))
                        switch (t) {
                            case "close":
                                o.close(i.startEvent);
                                break;
                            case "toggleControls":
                                o.toggleControls(!0);
                                break;
                            case "next":
                                o.next();
                                break;
                            case "nextOrClose":
                                1 < o.group.length ? o.next() : o.close(i.startEvent);
                                break;
                            case "zoom":
                                "image" == r.type && (r.isLoaded || r.$ghost) && (o.canPan() ? o.scaleToFit() : o.isScaledDown() ? o.scaleToActual(s, l) : o.group.length < 2 && o.close(i.startEvent));
                        }
                };
            if ((!n.originalEvent || 2 != n.originalEvent.button) && (t.is("img") || !(s > t[0].clientWidth + t.offset().left))) {
                if (t.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container")) e = "Outside";
                else if (t.is(".fancybox-slide")) e = "Slide";
                else {
                    if (!o.current.$content || !o.current.$content.find(t).addBack().filter(t).length) return;
                    e = "Content";
                }
                if (i.tapped) {
                    if ((clearTimeout(i.tapped), (i.tapped = null), 50 < Math.abs(s - i.tapX) || 50 < Math.abs(l - i.tapY))) return this;
                    c("dblclick" + e);
                } else
                    (i.tapX = s),
                        (i.tapY = l),
                        r.opts["dblclick" + e] && r.opts["dblclick" + e] !== r.opts["click" + e]
                            ? (i.tapped = setTimeout(function () {
                                (i.tapped = null), c("click" + e);
                            }, 500))
                            : c("click" + e);
                return this;
            }
        }),
        m(s).on("onActivate.fb", function (e, t) {
            t && !t.Guestures && (t.Guestures = new n(t));
        }),
        (function (a, s) {
            s.extend(!0, s.fancybox.defaults, {
                btnTpl: {
                    slideShow: '<button data-fancybox-play class="fancybox-button fancybox-button--play" title=""><svg viewBox="0 0 40 40"><path d="M13,12 L27,20 L13,27 Z" /><path d="M15,10 v19 M23,10 v19" /></svg></button>',
                },
                slideShow: { autoStart: !1, speed: 3e3 },
            });
            var n = function (e) {
                (this.instance = e), this.init();
            };
            s.extend(n.prototype, {
                timer: null,
                isActive: !1,
                $button: null,
                init: function () {
                    var e = this;
                    (e.$button = e.instance.$refs.toolbar.find("[data-fancybox-play]").on("click", function () {
                        e.toggle();
                    })),
                    (e.instance.group.length < 2 || !e.instance.group[e.instance.currIndex].opts.slideShow) && e.$button.hide();
                },
                set: function (e) {
                    var t = this;
                    t.instance && t.instance.current && (!0 === e || t.instance.current.opts.loop || t.instance.currIndex < t.instance.group.length - 1)
                        ? (t.timer = setTimeout(function () {
                            t.isActive && t.instance.jumpTo((t.instance.currIndex + 1) % t.instance.group.length);
                        }, t.instance.current.opts.slideShow.speed))
                        : (t.stop(), (t.instance.idleSecondsCounter = 0), t.instance.showControls());
                },
                clear: function () {
                    clearTimeout(this.timer), (this.timer = null);
                },
                start: function () {
                    var e = this.instance.current;
                    e && ((this.isActive = !0), this.$button.attr("title", e.opts.i18n[e.opts.lang].PLAY_STOP).removeClass("fancybox-button--play").addClass("fancybox-button--pause"), this.set(!0));
                },
                stop: function () {
                    var e = this.instance.current;
                    this.clear(), this.$button.attr("title", e.opts.i18n[e.opts.lang].PLAY_START).removeClass("fancybox-button--pause").addClass("fancybox-button--play"), (this.isActive = !1);
                },
                toggle: function () {
                    this.isActive ? this.stop() : this.start();
                },
            }),
                s(a).on({
                    "onInit.fb": function (e, t) {
                        t && !t.SlideShow && (t.SlideShow = new n(t));
                    },
                    "beforeShow.fb": function (e, t, n, i) {
                        var o = t && t.SlideShow;
                        i ? o && n.opts.slideShow.autoStart && o.start() : o && o.isActive && o.clear();
                    },
                    "afterShow.fb": function (e, t, n) {
                        var i = t && t.SlideShow;
                        i && i.isActive && i.set();
                    },
                    "afterKeydown.fb": function (e, t, n, i, o) {
                        var r = t && t.SlideShow;
                        !r || !n.opts.slideShow || (80 !== o && 32 !== o) || s(a.activeElement).is("button,a,input") || (i.preventDefault(), r.toggle());
                    },
                    "beforeClose.fb onDeactivate.fb": function (e, t) {
                        var n = t && t.SlideShow;
                        n && n.stop();
                    },
                }),
                s(a).on("visibilitychange", function () {
                    var e = s.fancybox.getInstance(),
                        t = e && e.SlideShow;
                    t && t.isActive && (a.hidden ? t.clear() : t.set());
                });
        })(document, window.jQuery || jQuery),
        (function (r, n) {
            var t = (function () {
                for (
                    var e = [
                            ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
                            ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
                            ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
                            ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
                            ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"],
                        ],
                        t = {},
                        n = 0;
                    n < e.length;
                    n++
                ) {
                    var i = e[n];
                    if (i && i[1] in r) {
                        for (var o = 0; o < i.length; o++) t[e[0][o]] = i[o];
                        return t;
                    }
                }
                return !1;
            })();
            if (t) {
                var i = {
                    request: function (e) {
                        (e = e || r.documentElement)[t.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
                    },
                    exit: function () {
                        r[t.exitFullscreen]();
                    },
                    toggle: function (e) {
                        (e = e || r.documentElement), this.isFullscreen() ? this.exit() : this.request(e);
                    },
                    isFullscreen: function () {
                        return Boolean(r[t.fullscreenElement]);
                    },
                    enabled: function () {
                        return Boolean(r[t.fullscreenEnabled]);
                    },
                };
                n.extend(!0, n.fancybox.defaults, {
                    btnTpl: { fullScreen: '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fullscreen" title=""><svg viewBox="0 0 40 40"><path d="M9,12 v16 h22 v-16 h-22 v8" /></svg></button>' },
                    fullScreen: { autoStart: !1 },
                }),
                    n(r).on({
                        "onInit.fb": function (e, t) {
                            t && t.group[t.currIndex].opts.fullScreen
                                ? (t.$refs.container.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function (e) {
                                    e.stopPropagation(), e.preventDefault(), i.toggle();
                                }),
                                t.opts.fullScreen && !0 === t.opts.fullScreen.autoStart && i.request(),
                                    (t.FullScreen = i))
                                : t && t.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
                        },
                        "afterKeydown.fb": function (e, t, n, i, o) {
                            t && t.FullScreen && 70 === o && (i.preventDefault(), t.FullScreen.toggle());
                        },
                        "beforeClose.fb": function (e, t) {
                            t && t.FullScreen && t.$refs.container.hasClass("fancybox-is-fullscreen") && i.exit();
                        },
                    }),
                    n(r).on(t.fullscreenchange, function () {
                        var e = i.isFullscreen(),
                            t = n.fancybox.getInstance();
                        t &&
                        (t.current && "image" === t.current.type && t.isAnimating && (t.current.$content.css("transition", "none"), (t.isAnimating = !1), t.update(!0, !0, 0)),
                            t.trigger("onFullscreenChange", e),
                            t.$refs.container.toggleClass("fancybox-is-fullscreen", e));
                    });
            } else n && n.fancybox && (n.fancybox.defaults.btnTpl.fullScreen = !1);
        })(document, window.jQuery || jQuery),
        (function (e, r) {
            var a = "fancybox-thumbs",
                s = a + "-active";
            r.fancybox.defaults = r.extend(
                !0,
                {
                    btnTpl: {
                        thumbs:
                            '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title=""><svg viewBox="0 0 120 120"><path d="M30,30 h14 v14 h-14 Z M50,30 h14 v14 h-14 Z M70,30 h14 v14 h-14 Z M30,50 h14 v14 h-14 Z M50,50 h14 v14 h-14 Z M70,50 h14 v14 h-14 Z M30,70 h14 v14 h-14 Z M50,70 h14 v14 h-14 Z M70,70 h14 v14 h-14 Z" /></svg></button>',
                    },
                    thumbs: { autoStart: !1, hideOnClose: !0, parentEl: ".fancybox-container", axis: "y" },
                },
                r.fancybox.defaults
            );
            var i = function (e) {
                this.init(e);
            };
            r.extend(i.prototype, {
                $button: null,
                $grid: null,
                $list: null,
                isVisible: !1,
                isActive: !1,
                init: function (e) {
                    var t,
                        n,
                        i = this;
                    (((i.instance = e).Thumbs = i).opts = e.group[e.currIndex].opts.thumbs),
                        (t = (t = e.group[0]).opts.thumb || (!(!t.opts.$thumb || !t.opts.$thumb.length) && t.opts.$thumb.attr("src"))),
                    1 < e.group.length && (n = (n = e.group[1]).opts.thumb || (!(!n.opts.$thumb || !n.opts.$thumb.length) && n.opts.$thumb.attr("src"))),
                        (i.$button = e.$refs.toolbar.find("[data-fancybox-thumbs]")),
                        i.opts && t && n && t && n
                            ? (i.$button.show().on("click", function () {
                                i.toggle();
                            }),
                                (i.isActive = !0))
                            : i.$button.hide();
                },
                create: function () {
                    var n,
                        e = this,
                        t = e.instance,
                        i = e.opts.parentEl,
                        o = [];
                    e.$grid ||
                    ((e.$grid = r('<div class="' + a + " " + a + "-" + e.opts.axis + '"></div>').appendTo(t.$refs.container.find(i).addBack().filter(i))),
                        e.$grid.on("click", "li", function () {
                            t.jumpTo(r(this).attr("data-index"));
                        })),
                    e.$list || (e.$list = r("<ul>").appendTo(e.$grid)),
                        r.each(t.group, function (e, t) {
                            (n = t.opts.thumb || (t.opts.$thumb ? t.opts.$thumb.attr("src") : null)) || "image" !== t.type || (n = t.src),
                                o.push('<li data-index="' + e + '" tabindex="0" class="fancybox-thumbs-loading"' + (n && n.length ? ' style="background-image:url(' + n + ')" />' : "") + "></li>");
                        }),
                        (e.$list[0].innerHTML = o.join("")),
                    "x" === e.opts.axis && e.$list.width(parseInt(e.$grid.css("padding-right"), 10) + t.group.length * e.$list.children().eq(0).outerWidth(!0));
                },
                focus: function (e) {
                    var t,
                        n,
                        i = this,
                        o = i.$list,
                        r = i.$grid;
                    i.instance.current &&
                    ((n = (t = o
                        .children()
                        .removeClass(s)
                        .filter('[data-index="' + i.instance.current.index + '"]')
                        .addClass(s)).position()),
                        "y" === i.opts.axis && (n.top < 0 || n.top > o.height() - t.outerHeight())
                            ? o.stop().animate({ scrollTop: o.scrollTop() + n.top }, e)
                            : "x" === i.opts.axis && (n.left < r.scrollLeft() || n.left > r.scrollLeft() + (r.width() - t.outerWidth())) && o.parent().stop().animate({ scrollLeft: n.left }, e));
                },
                update: function () {
                    var e = this;
                    e.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible),
                        e.isVisible ? (e.$grid || e.create(), e.instance.trigger("onThumbsShow"), e.focus(0)) : e.$grid && e.instance.trigger("onThumbsHide"),
                        e.instance.update();
                },
                hide: function () {
                    (this.isVisible = !1), this.update();
                },
                show: function () {
                    (this.isVisible = !0), this.update();
                },
                toggle: function () {
                    (this.isVisible = !this.isVisible), this.update();
                },
            }),
                r(e).on({
                    "onInit.fb": function (e, t) {
                        var n;
                        t && !t.Thumbs && (n = new i(t)).isActive && !0 === n.opts.autoStart && n.show();
                    },
                    "beforeShow.fb": function (e, t, n, i) {
                        var o = t && t.Thumbs;
                        o && o.isVisible && o.focus(i ? 0 : 250);
                    },
                    "afterKeydown.fb": function (e, t, n, i, o) {
                        var r = t && t.Thumbs;
                        r && r.isActive && 71 === o && (i.preventDefault(), r.toggle());
                    },
                    "beforeClose.fb": function (e, t) {
                        var n = t && t.Thumbs;
                        n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide();
                    },
                });
        })(document, window.jQuery || jQuery),
        (o = document),
        (a = window.jQuery || jQuery).extend(!0, a.fancybox.defaults, {
            btnTpl: {
                share:
                    '<button data-fancybox-share class="fancybox-button fancybox-button--share" title=""><svg viewBox="0 0 40 40"><path d="M6,30 C8,18 19,16 23,16 L23,16 L23,10 L33,20 L23,29 L23,24 C19,24 8,27 6,30 Z"></svg></button>',
            },
            share: {
                url: function (e, t) {
                    return (!e.currentHash && "inline" !== t.type && "html" !== t.type && (t.origSrc || t.src)) || window.location;
                },
                tpl:
                    '<div class="fancybox-share"><h1></h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u="><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url=&text="><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url=&description=&media="><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="" /></p></div>',
            },
        }),
        a(o).on("click", "[data-fancybox-share]", function () {
            var e,
                t,
                n,
                i,
                o = a.fancybox.getInstance(),
                r = o.current || null;
            r &&
            ("function" === a.type(r.opts.share.url) && (e = r.opts.share.url.apply(r, [o, r])),
                (t = r.opts.share.tpl
                    .replace(/\{\{media\}\}/g, "image" === r.type ? encodeURIComponent(r.src) : "")
                    .replace(/\{\{url\}\}/g, encodeURIComponent(e))
                    .replace(
                        /\{\{url_raw\}\}/g,
                        ((n = e),
                            (i = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#x2F;", "`": "&#x60;", "=": "&#x3D;" }),
                            String(n).replace(/[&<>"'`=\/]/g, function (e) {
                                return i[e];
                            }))
                    )
                    .replace(/\{\{descr\}\}/g, o.$caption ? encodeURIComponent(o.$caption.text()) : "")),
                a.fancybox.open({
                    src: o.translate(o, t),
                    type: "html",
                    opts: {
                        animationEffect: !1,
                        afterLoad: function (e, t) {
                            o.$refs.container.one("beforeClose.fb", function () {
                                e.close(null, 0);
                            }),
                                t.$content.find(".fancybox-share__links a").click(function () {
                                    return window.open(this.href, "Share", "width=550, height=450"), !1;
                                });
                        },
                    },
                }));
        }),
        (function (r, a, o) {
            function s() {
                var e = a.location.hash.substr(1),
                    t = e.split("-"),
                    n = (1 < t.length && /^\+?\d+$/.test(t[t.length - 1]) && parseInt(t.pop(-1), 10)) || 1;
                return { hash: e, index: n < 1 ? 1 : n, gallery: t.join("-") };
            }
            function t(e) {
                "" !== e.gallery &&
                o("[data-fancybox='" + o.escapeSelector(e.gallery) + "']")
                    .eq(e.index - 1)
                    .trigger("click.fb-start");
            }
            function l(e) {
                var t, n;
                return !!e && "" !== (n = (t = e.current ? e.current.opts : e.opts).hash || (t.$orig ? t.$orig.data("fancybox") : "")) && n;
            }
            o.escapeSelector ||
            (o.escapeSelector = function (e) {
                return (e + "").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (e, t) {
                    return t ? ("\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
                });
            }),
                o(function () {
                    !1 !== o.fancybox.defaults.hash &&
                    (o(r).on({
                        "onInit.fb": function (e, t) {
                            var n, i;
                            !1 !== t.group[t.currIndex].opts.hash && ((n = s()), (i = l(t)) && n.gallery && i == n.gallery && (t.currIndex = n.index - 1));
                        },
                        "beforeShow.fb": function (e, t, n, i) {
                            var o;
                            n &&
                            !1 !== n.opts.hash &&
                            (o = l(t)) &&
                            ((t.currentHash = o + (1 < t.group.length ? "-" + (n.index + 1) : "")),
                            a.location.hash !== "#" + t.currentHash &&
                            (t.origHash || (t.origHash = a.location.hash),
                            t.hashTimer && clearTimeout(t.hashTimer),
                                (t.hashTimer = setTimeout(function () {
                                    "replaceState" in a.history
                                        ? (a.history[i ? "pushState" : "replaceState"]({}, r.title, a.location.pathname + a.location.search + "#" + t.currentHash), i && (t.hasCreatedHistory = !0))
                                        : (a.location.hash = t.currentHash),
                                        (t.hashTimer = null);
                                }, 300))));
                        },
                        "beforeClose.fb": function (e, t, n) {
                            !1 !== n.opts.hash &&
                            (l(t),
                                t.currentHash && t.hasCreatedHistory
                                    ? a.history.back()
                                    : t.currentHash && ("replaceState" in a.history ? a.history.replaceState({}, r.title, a.location.pathname + a.location.search + (t.origHash || "")) : (a.location.hash = t.origHash)),
                                (t.currentHash = null),
                                clearTimeout(t.hashTimer));
                        },
                    }),
                        o(a).on("hashchange.fb", function () {
                            var i,
                                e = s();
                            o.each(o(".fancybox-container").get().reverse(), function (e, t) {
                                var n = o(t).data("FancyBox");
                                if (n.currentHash) return (i = n), !1;
                            }),
                                i ? !i.currentHash || i.currentHash === e.gallery + "-" + e.index || (1 === e.index && i.currentHash == e.gallery) || ((i.currentHash = null), i.close()) : "" !== e.gallery && t(e);
                        }),
                        setTimeout(function () {
                            o.fancybox.getInstance() || t(s());
                        }, 50));
                });
        })(document, window, window.jQuery || jQuery),
        (r = document),
        (d = window.jQuery || jQuery),
        (f = new Date().getTime()),
        d(r).on({
            "onInit.fb": function (e, i, t) {
                i.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll", function (e) {
                    var t = i.current,
                        n = new Date().getTime();
                    i.group.length < 2 ||
                    !1 === t.opts.wheel ||
                    ("auto" === t.opts.wheel && "image" !== t.type) ||
                    (e.preventDefault(),
                        e.stopPropagation(),
                    t.$slide.hasClass("fancybox-animated") || ((e = e.originalEvent || e), n - f < 250 || ((f = n), i[(-e.deltaY || -e.deltaX || e.wheelDelta || -e.detail) < 0 ? "next" : "previous"]())));
                });
            },
        }));
})(Waypoint);
